import React from 'react';

export function CompanyFilesPage() {
    return (
        <div>
            Company Files Page
        </div>
    )
}